import { transform } from 'ol/proj.js';

export default function reprojectionCoordinate(coordinate, from, to) {
    var coordinatesToChange = [coordinate];
    var result = [];
    if (from == to) {
        result = [coordinate];
    } else {
        coordinatesToChange.forEach((coordinateToChange, ind) => {
            if (coordinateToChange.length > 2) {
                var new_coordinate = [];
                for (var i = 0; i < coordinateToChange.length / 2; i++) {
                    var new_coord = new transform([coordinateToChange[i * 2], coordinateToChange[i * 2 + 1]], from, to);
                    new_coordinate[i * 2] = new_coord[0];
                    new_coordinate[i * 2 + 1] = new_coord[1];
                }
                result[ind] = new_coordinate;
            } else if (coordinateToChange.length == 2) {
                result[ind] = new transform(coordinateToChange, from, to);
            }
        });
    }
    return result[0];
}
